let formApp

if(document.getElementById("js-map-form-data")) {
    formApp = new Vue({
        el: '#js-map-form-data',
        data() {
            return {
                address: '',
                availability: 0,
                speed: '1',
                unit: 'Gbps',
            }
        },
        computed: {
            availability_vinor() {
                return this.address.search(/Praha 9 - Vinoř/) >= 0
            },
            availability_string() {
                return this.availability === 2 ?
                    "Internet od Scancomu je dostupný!" :
                    (this.availability === 1 && this.availability_vinor ?
                            "Internet od Scancomu brzy na Vaší adrese!" :
                            "Internet od Scancomu zatím není dostupný.")
            },
            availability_class() {
                return this.availability === 2 ?
                    "c-map-form--available" :
                        (this.availability === 1 && this.availability_vinor ?
                            "c-map-form--available" :
                            "c-map-form--not-yet-available")
            },
            speed_class() {
                return this.unit === 'Gbps' ?
                    "c-map-form__speed-number--fast" :
                    "c-map-form__speed-number--medium"
            },
        },
        methods: {
            injectNewPoint(point) {
                this.address = point.address
                this.availability = point.status
                this.speed = point.speed
                this.unit = point.unit
            }
        },
    })
}